'use client'

import { useSyncExternalStore, type ReactNode } from 'react'
import { classifyAnalyticsUrl, type AnalyticsUrlClass } from '@/lib/analytics-url-policy'

function subscribeToBrowserNavigation(onStoreChange: () => void): () => void {
  window.addEventListener('hashchange', onStoreChange)
  window.addEventListener('popstate', onStoreChange)

  return () => {
    window.removeEventListener('hashchange', onStoreChange)
    window.removeEventListener('popstate', onStoreChange)
  }
}

/**
 * Por defecto bloquea credenciales Y rutas-capacidad: es lo que necesitan los
 * tags de terceros (GTM, Vercel), que publicarían la URL entera. El
 * consentimiento y PostHog sólo bloquean `credential` (ADR-054).
 */
const THIRD_PARTY_BLOCKS: readonly AnalyticsUrlClass[] = ['credential', 'capability']

export function AnalyticsBoundary({
  children,
  blocks = THIRD_PARTY_BLOCKS,
}: {
  children: ReactNode
  blocks?: readonly AnalyticsUrlClass[]
}) {
  const isUrlSafe = useSyncExternalStore(
    subscribeToBrowserNavigation,
    () => !blocks.includes(classifyAnalyticsUrl()),
    () => false
  )

  return isUrlSafe ? children : null
}
